import { api } from "../lib/api";
import InvoiceManager from "../components/invoices/InvoiceManager";

export default function Invoices() {
  return (
    <InvoiceManager
      api={api}
      module="rental"
      title="Invoices"
      subtitle="Create, send and track payment on rental & chauffeur invoices."
      allowBranding={false}
      sourceConfig={{
        label: "Booking",
        listPath: "/bookings",
        id: (b) => b.id,
        optionLabel: (b) => `${b.customer_name || "Guest"} · ${(b.start_datetime || "").slice(0, 10) || "no date"}${b.vehicle_label ? ` · ${b.vehicle_label}` : b.tour_name ? ` · ${b.tour_name}` : ""}`,
        search: [
          { key: "first", label: "First name", get: (b) => b.customer_name },
          { key: "last", label: "Last name", get: (b) => b.customer_name },
          { key: "vehicle", label: "Vehicle", get: (b) => b.vehicle_label },
        ],
      }}
    />
  );
}
